var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeverbounce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 269 21",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nst0{fill-rule:evenodd;clip-rule:evenodd;fill:#040a29}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "nst0",
    d: "M15.5 0H19v20h-3.8L3.5 5.4V20H0V0h3.5l12 14.9V0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "nst0",
    d: "M39.6 0v3.2H28.5v5.3h10v3h-10v5.3H40V20H25V0h14.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "nst0",
    d: "M53.9 20h-3.8L42 0h3.8L52 14.9 58.2 0H62l-8.1 20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "nst0",
    d: "M80.6 0v3.2H69.5v5.3h10v3h-10v5.3H81V20H66V0h14.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "nst0",
    d: "M97.6 9.3c.7-.6 1-1.5 1-2.8s-.4-2.2-1.1-2.7c-.7-.5-2-.7-3.8-.7h-4.3v7.2h4.2c2-.1 3.3-.4 4-1zm4.5-2.8c0 3.3-1.5 5.4-4.4 6.2L103 20h-4.3l-4.8-6.7h-4.5V20H86V0h7.5c3.1 0 5.3.5 6.6 1.5 1.3 1.1 2 2.7 2 5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "nst0",
    d: "M111.4 16.9h5.3c1.2 0 2.2-.2 2.9-.6.7-.4 1-1.1 1-2.2 0-1.8-1.4-2.7-4.3-2.7h-4.9v5.5zm0-8.6h4.3c2.4 0 3.7-.8 3.7-2.5 0-1-.3-1.6-.9-2.1-.6-.4-1.5-.6-2.8-.6h-4.3v5.2zm5.4 11.7H108V0h7.8c1.4 0 2.5.2 3.5.5s1.7.8 2.2 1.3c.9 1 1.4 2.2 1.4 3.5 0 1.6-.5 2.7-1.5 3.5-.4.3-.6.4-.7.5-.1.1-.4.2-.7.3 1.2.3 2.2.8 3 1.7.7.8 1.1 1.9 1.1 3.2 0 1.4-.5 2.6-1.4 3.7-1.3 1.2-3.2 1.8-5.9 1.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "nst0",
    d: "M143.5 5.3c-1.4-1.4-3-2.1-5-2.1s-3.6.7-5 2.1c-1.4 1.4-2 3.2-2 5.2s.7 3.8 2 5.2c1.4 1.4 3 2.1 5 2.1s3.6-.7 5-2.1c1.4-1.4 2-3.2 2-5.2s-.6-3.8-2-5.2zM146 18c-2 2-4.5 3-7.5 3s-5.5-1-7.5-3-3-4.5-3-7.5 1-5.5 3-7.5 4.5-3 7.5-3 5.5 1 7.5 3 3 4.5 3 7.5-1 5.5-3 7.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "nst0",
    d: "M158.8 15.3c.9 1.1 2.2 1.6 3.7 1.6 1.6 0 2.8-.5 3.7-1.6.9-1.1 1.4-2.5 1.4-4.3V0h3.4v11.1c0 2.9-.8 5-2.4 6.6-1.6 1.5-3.6 2.3-6.1 2.3-2.5 0-4.5-.8-6.1-2.3-1.6-1.5-2.4-3.7-2.4-6.6V0h3.4v11c0 1.8.4 3.2 1.4 4.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "nst0",
    d: "M192.5 0h3.5v20h-3.8L180.5 5.4V20H177V0h3.5l12 14.9V0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "nst0",
    d: "M211.7 17.7c1.2 0 2.2-.2 3.1-.6.9-.4 1.8-1 2.7-1.9l2.2 2.3c-2.2 2.4-4.8 3.6-7.9 3.6s-5.7-1-7.7-3-3.1-4.5-3.1-7.5 1-5.5 3.1-7.5 4.7-3 7.9-3 5.8 1.2 8 3.5L217.8 6c-1-.9-1.9-1.6-2.8-1.9s-1.9-.6-3.1-.6c-2.1 0-3.8.7-5.2 2-1.4 1.3-2.1 3-2.1 5.1 0 2.1.7 3.8 2.1 5.2 1.4 1.2 3.1 1.9 5 1.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "nst0",
    d: "M245 0l-1.9 3.2h-14.7v3.4h12.8l-1.8 3h-11v7.2h6.7l-1.8 3.2H225V0h20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1e9fc4",
    d: "M247.9 0l-1.8 3.2h18.1L250.5 10l-6.7-3.1-1.8 3 8.5 3.7 15.1-7.5.1 10.7h-27.9L236 20h33V0h-21.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "nst0",
    d: "M245 0l-1.9 3.2h-14.7v3.4h12.8l-1.8 3h-11v7.2h6.7l-1.8 3.2H225V0h20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeverbounce);
export default __webpack_public_path__ + "static/media/neverbounce.a93a9be1da2567a5fc3f1cb1595ef981.svg";
export { ForwardRef as ReactComponent };